export default (function (siteVariables) { return ({
    statusBorderColor: siteVariables.black,
}); });
